import { Pipe, PipeTransform } from '@angular/core';
import { Property } from 'src/app/core/models/project/property.model';

@Pipe({
  name: 'propertiesAreActive',
})
export class PropertiesAreActivePipe implements PipeTransform {
  transform(properties: Property[]): boolean {
    if (properties?.length === 0) {
      return false;
    }

    return properties.some((prop) => {
        return Property.isActive(prop);
      });
  }
}
